import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import axios from "axios";
import "font-awesome/css/font-awesome.min.css";
import { useContext, useState } from 'react';
import { useHistory } from "react-router-dom";
import "semantic-ui-css/semantic.min.css";
import { Container, Grid, Modal } from "semantic-ui-react";
import { loginCookieName } from "../App";
import { SettingsContext } from "../context";
import { eraseCookie, setCookie } from "../Cookie";


const loginTranslations = {
  en: {
    signingIn: "Signing in, please wait",
    success: "Login successful",
    failure: "Login failed",
    title: "Sign in",
    email: "Email Address",
    password: "Password",
    button: "Sign In",
  },
  tr: {
    signingIn: "Giriş yapılıyor, lütfen bekleyin",
    success: "Giriş başarılı",
    failure: "Giriş başarısız",
    title: "Giriş yap",
    email: "E-posta adresi",
    password: "Şifre",
    button: "Giriş yap",
  },
};

const getLoginTranslations = () => {
  const language = window.navigator.language || window.navigator.userLanguage || "en";
  return language.toLowerCase().startsWith("tr") ? loginTranslations.tr : loginTranslations.en;
};

function LoginForm() {

  const history = useHistory();
  const { setAuthenticationToken } = useContext(SettingsContext);
  const [modalOpen, setModalOpen] = useState(false);
  const [token, setToken] = useState(false);
  const [notification, setNotification] = useState();
  const theme = createTheme();
  const translations = getLoginTranslations();


  const handleSubmit = async (event) => {

    event.preventDefault();
    setModalOpen(true);
    setNotification(translations.signingIn)

    const data = new FormData(event.currentTarget);
    let email = data.get('email');
    let password = data.get('password');
    let token = initializeToken(email, password);
    let loggedIn = await loginUser(token);

    if (loggedIn)
      showSuccessLogin(token);
    else
      showFailureLogin();
  };

  const initializeToken = (username, password) => {
    let token = "Basic ";
    token += getBase64(username, password);
    setToken(token);
    setCookie(loginCookieName, token);
    return token;
  }

  const getBase64 = (username, password) => {
    const encodedString = Buffer.from(username + ":" + password).toString('base64');
    return encodedString;
  }

  const showSuccessLogin = (token) => {
    setNotification(translations.success)
    setAuthenticationToken(token);

    setTimeout(() => {
      setModalOpen(false);
      setNotification(null)

      const path = history.location.state?.productUrl || "/";
      history.push(path)
    }, 3000);

  }

  const showFailureLogin = () => {

    setNotification(translations.failure)
    eraseCookie(loginCookieName);
    setAuthenticationToken("")
    setTimeout(() => {
      setModalOpen(false);
      setNotification(null)
    }, 3000);
  }

  const loginUser = async (token) => {

    let formData = new FormData();
    return (axios({
      method: 'post',
      url: process.env.REACT_APP_BACKEND + 'api/login/editor',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': token
      }
    }).
      then((res) => {

        return res.data.result == "True";
      },
        (rej) => {
          return false;
        }
      ));
  }

  return (

    <div className="loginFormTemplate">

      <ThemeProvider theme={theme}>
        <Container component="main" >
          <CssBaseline
          />
          <Box
            sx={{
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }} />

            {translations.title}

            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label={translations.email}
                name="email"
                autoComplete="email"
                autoFocus />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label={translations.password}
                type="password"
                id="password"
                autoComplete="current-password" />

              <button
                className="saveButton login"
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}  >
                {translations.button}
              </button>
              <Grid container>
                <Grid >

                </Grid>

              </Grid>
            </Box>
          </Box>
        </Container>
      </ThemeProvider>
      <Modal
        onOpen={() => setModalOpen(true)}
        onClose={() => setModalOpen(false)}
        open={modalOpen}
        className="commentRepModal"
        dimmer="blurring"
        size="small"
        closeOnDimmerClick={false}
      >
        <Modal.Content>
          <div className="loadingModal">
            <div className="lds-default">
              <p>{notification}</p>
            </div>
          </div>
        </Modal.Content>
      </Modal>
    </div>
  );

}

export default LoginForm;
